import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { publicApi } from "@/lib/api";
import { Reveal } from "@/components/motion/Reveal";
import featureFlags from "@/config/featureFlags.json";

export default function Sectors() {
  const [items, setItems] = useState([]);
  useEffect(() => { publicApi.sectors().then(setItems).catch(() => setItems([])); }, []);

  return (
    <section id="sectores" className="relative py-24 md:py-32 border-t border-[#1A1A1A]/10 bg-[#EFEBE2]" data-testid="sectors-section">
      <div className="mx-auto max-w-[1440px] px-5 md:px-10">
        <Reveal>
          <div className="eyebrow mb-6">— 07 · Sectores</div>
          <h2 className="display-2 max-w-4xl">Experiencia en <em className="italic text-[#1B3B2B]">diferentes sectores</em>.</h2>
        </Reveal>

        <div className="mt-16 flex flex-wrap gap-3">
          {items.map((s, i) => (
            <Reveal key={s.id} delay={i * 0.03}>
              {featureFlags.showSuccessCases ? (
                <Link
                  to={`/casos-de-exito?sector=${encodeURIComponent(s.nombre)}`}
                  className="inline-flex items-center gap-3 px-5 py-3 border border-[#1A1A1A]/25 rounded-full text-sm hover:bg-[#1A1A1A] hover:text-[#F9F6F0] transition-colors"
                  data-testid={`sector-${i}`}
                >
                  <span className="text-[10px] tracking-widest text-[#4A4A4A] group-hover:text-[#F9F6F0]/50">{String(i + 1).padStart(2, "0")}</span>
                  {s.nombre}
                </Link>
              ) : (
                <div
                  className="inline-flex items-center gap-3 px-5 py-3 border border-[#1A1A1A]/25 rounded-full text-sm"
                  data-testid={`sector-${i}`}
                >
                  <span className="text-[10px] tracking-widest text-[#4A4A4A]">{String(i + 1).padStart(2, "0")}</span>
                  {s.nombre}
                </div>
              )}
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
